import React, { useState } from 'react';
import { MetapromptingMessage } from '../types';
import './MessageItem.css';

interface MessageItemProps {
  message: MetapromptingMessage;
}

export const MessageItem: React.FC<MessageItemProps> = ({ message }) => {
  const [copySuccess, setCopySuccess] = useState(false);

  const roleLabels = {
    user: 'Usuario',
    basic: 'Modelo Básico',
    reasoner: 'Modelo Razonador',
    system: 'Sistema'
  };

  const modelVersions = {
    basic: 'GPT-4o-mini (latest)',
    reasoner: 'o3-mini'
  };

  const roleIcons = {
    user: '👤',
    basic: '🤖',
    reasoner: '🧠',
    system: '⚙️'
  };

  const isLeftSide = message.role === 'basic' || message.role === 'system';
  const isRightSide = message.role === 'reasoner' || message.role === 'user';

  const handleCopyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(message.content);
      setCopySuccess(true);
      setTimeout(() => setCopySuccess(false), 2000);
    } catch (err) {
      console.error('Error al copiar:', err);
    }
  };

  // Si es el prompt final, mostrar con un diseño especial
  if (message.isFinalPrompt) {
    return (
      <div className="message-wrapper message-center">
        <div className="message-bubble message-final-prompt">
          <div className="message-header">
            <div className="message-header-left">
              <span className="message-icon">🎯</span>
              <span className="message-role">Prompt Final Mejorado</span>
            </div>
            <div className="message-actions">
              <button 
                onClick={handleCopyToClipboard}
                className={`copy-button ${copySuccess ? 'copy-success' : ''}`}
                title="Copiar prompt"
              >
                {copySuccess ? '✅' : '📋'}
              </button>
            </div>
          </div>
          <div className="message-content final-prompt-content">
            {message.content.split('\n').map((line, index) => (
              <React.Fragment key={index}>
                {line}
                {index < message.content.split('\n').length - 1 && <br />}
              </React.Fragment>
            ))}
          </div>
          <div className="message-footer">
            <span className="message-time">
              {new Date(message.timestamp).toLocaleTimeString('es-ES', { 
                hour: '2-digit', 
                minute: '2-digit' 
              })}
            </span>
            <span className="final-prompt-note">¡Listo para usar! 🚀</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={`message-wrapper message-${isLeftSide ? 'left' : 'right'}`}>
      <div className={`message-bubble message-${message.role}`}>
        <div className="message-header">
          <div className="message-header-left">
            <span className="message-icon">{roleIcons[message.role]}</span>
            <span className="message-role">
              {roleLabels[message.role]}
            </span>
            {(message.role === 'basic' || message.role === 'reasoner') && (
              <span className="message-model">{modelVersions[message.role]}</span>
            )}
          </div>
          {message.iteration && (
            <span className="message-iteration">Iteración {message.iteration}</span>
          )}
        </div>
        <div className="message-content">
          {message.content.split('\n').map((line, index) => (
            <React.Fragment key={index}>
              {line}
              {index < message.content.split('\n').length - 1 && <br />}
            </React.Fragment>
          ))}
          {message.isStreaming && (
            <span className="streaming-cursor">▊</span>
          )}
        </div>
        <div className="message-footer">
          <span className="message-time">
            {new Date(message.timestamp).toLocaleTimeString('es-ES', { 
              hour: '2-digit', 
              minute: '2-digit' 
            })}
          </span>
        </div>
      </div>
    </div>
  );
};